module.exports = __webpack_public_path__ + "static/media/enjoy_now.f9d82912.svg";